import { useContext, useEffect, useState } from "react";
import AuthContext from "../contexts/AuthContext";
import axios from 'axios';
import {Tooltip, PieChart, Pie, Cell } from 'recharts';
import { Box, Heading} from '@chakra-ui/react';

const currencySymbols = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
};

const AssetsAllocationPieChart = ({ data }) => {
    const {getToken} = useContext(AuthContext);
    const [allocationData, setAllocationData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const token = getToken();
            try {
                const allocationResponse = await axios.get('/api/assets_allocation', {
                headers: { Authorization: `Bearer ${token}` }
                });
                setAllocationData(allocationResponse.data);
            } catch (error) {
                console.error('Failed to fetch data', error);
            }
        };

        fetchData();
    }, [getToken]);

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AA00FF'];

    const pie_label = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x  = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy  + radius * Math.sin(-midAngle * RADIAN);
      
        return (
          <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {/* {`${allocationData[index]["asset_type"]} - ${(percent * 100).toFixed(0)}%`} */}
            {`${(percent * 100).toFixed(0)}%`}
          </text>
        );
    }

    const customTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
        const { name, value, payload: { currency } } = payload[0];
        const currencySymbol = currencySymbols[currency] || currency; // Use symbol if available, otherwise use currency code
        return (
            <Box bg="white" p={2} borderRadius="md" boxShadow="md">
                <p>{`${name}: ${value.toFixed(2)} ${currencySymbol}`}</p>
            </Box>
        );
      }
      return null;
  };

    return (
    <Box mb={4}>
        <Heading size="md" mb={4}>Assets Allocation</Heading>
        <PieChart width={400} height={400}>
          <Pie
            data={allocationData}
            dataKey="total_value"
            nameKey="asset_type"
            cx="50%"
            cy="50%"
            outerRadius={150}
            fill="#8884d8"
            label={pie_label}
          >
            {allocationData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={customTooltip}/>
        </PieChart>
    </Box>);
};

export default AssetsAllocationPieChart;